import { ROI_TABLE_COLUMN_KEYS, ROI_TABLE_ROW_KEYS } from './constants'
import { ReturnOnInvestmentTableProps, RoiTableColumns, RoiTableRows } from './types'
import styles from './SharesForm.module.scss'
import classNames from 'classnames'
import { Table } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'

const ReturnOnInvestmentTable = ({ expectedReturnPlentyOnly, expectedReturnPlentyWithBolt, shares }: ReturnOnInvestmentTableProps) => {
  // i18n
  const { t } = useTranslation(['boltXPlenty', 'common'])

  // Constants
  const advantageBoltGas = 60
  const advantageBoltElectricity = 60

  return (
    <Table
      columnKeys={ROI_TABLE_COLUMN_KEYS}
      rowKeys={ROI_TABLE_ROW_KEYS}
      highlightedColumn={RoiTableColumns.BOLT}
      hasRowHeader
      classes={{
        rowHeaderCell: styles['row-header-cell'],
        cell: styles.cell,
        table: styles['roi-table'],
        row: styles.row,
        headerCell: styles['col-header-cell']
      }}
      columnHeaders={{
        [RoiTableColumns.PLENTY]: (
          <span className="flex-col gap-200">
            <strong className="5 serif">Plenty</strong>
            <small className={classNames('text-sm', styles['header-text'])}>{t('shares.modal.table.plentyDesc', { count: shares })}</small>
          </span>
        ),
        [RoiTableColumns.BOLT]: (
          <span className="flex-col gap-200">
            <strong className="h5 serif">Plenty + Bolt</strong>
            <small className={classNames('text-sm', styles['header-text'])}>{t('shares.modal.table.boltDesc', { count: shares })}</small>
          </span>
        )
      }}
      rows={{
        [RoiTableRows.ROI]: {
          [RoiTableColumns.PLENTY]: t('common:formattedValue.currency', { value: expectedReturnPlentyOnly }),
          [RoiTableColumns.BOLT]: t('common:formattedValue.currency', { value: expectedReturnPlentyOnly }),
          rowHeaderText: t('shares.modal.table.roi')
        },
        [RoiTableRows.ADVANTAGE_EL]: {
          [RoiTableColumns.PLENTY]: '-',
          [RoiTableColumns.BOLT]: t('common:formattedValue.currency', { value: advantageBoltElectricity }),
          rowHeaderText: t('shares.modal.table.advantageElectricity')
        },
        [RoiTableRows.ADVANTAGE_GAS]: {
          [RoiTableColumns.PLENTY]: '-',
          [RoiTableColumns.BOLT]: t('common:formattedValue.currency', { value: advantageBoltGas }),
          rowHeaderText: t('shares.modal.table.advantageGas')
        },
        [RoiTableRows.TOTAL]: {
          [RoiTableColumns.PLENTY]: t('common:formattedValue.currency', { value: expectedReturnPlentyOnly }),
          [RoiTableColumns.BOLT]: t('common:formattedValue.currency', { value: expectedReturnPlentyWithBolt }),
          rowHeaderText: t('shares.modal.table.total')
        }
      }}
    />
  )
}

export default ReturnOnInvestmentTable
